export class Store {
    key;
    eventName;
    constructor(name) {
        this.key = `@awise/session:${name}-store`;
        this.eventName = `@awise/session:${name}-changed`;
    }
    value() {
        if (this.key in window) {
            return window[this.key];
        }
        else {
            return null;
        }
    }
    update(data) {
        window[this.key] = Object.freeze(data);
        this._dispatchOnChange();
    }
    clear() {
        delete window[this.key];
        this._dispatchOnChange();
    }
    onChange(callback) {
        const listener = (event) => callback(event.detail);
        window.addEventListener(this.eventName, listener);
        return () => window.removeEventListener(this.eventName, listener);
    }
    _dispatchOnChange() {
        window.dispatchEvent(new CustomEvent(this.eventName, { detail: this.value() }));
    }
}
export const auth = new Store('auth');
export const session = new Store('session');
//# sourceMappingURL=store.js.map